export default __webpack_public_path__ + "static/media/d-1.d3cf6189.jpg";